import { Component, OnInit, inject } from '@angular/core';
import { filter, first, switchMap, tap } from 'rxjs/operators';
import { ThemeService } from '../core/services/theme.service';
import { GameSearchService } from '../core/services/games/game-search.service';
import { UserService } from '../core/services/user/user.service';
import { PlatformService } from '../core/services/platform.service';
import {
  CookieMessageContentComponent,
} from '../core/shared/modules/toast-message/content/cookie-message-content/cookie-message-content.component';
import { ToastMessageService } from '../core/shared/modules/toast-message/toast-message.service';
import { CookieService } from 'ngx-unificator/services';
import { TranslationService } from '../core/services/translation/translation.service';
import { UserPaymentModeService } from '../core/services/user/user-payment-mode.service';
import { WindowService } from '../core/services/window.service';
import { LocalstorageService } from '../core/services/localstorage.service';
import { EpmCountryRestrictionService } from '../core/services/epm-country-restriction.service';
import { InstallAppService } from '../core/services/install-app.service';
import { ZendeskChatService } from '../core/services/zendesk/zendesk-chat.service';
import { ToTopComponent } from '../core/shared/layout/to-top/to-top.component';
import { GameIframeComponent } from '../core/shared/components/game-iframe/game-iframe.component';
import { ToastMessageComponent } from '../core/shared/modules/toast-message/toast-message.component';
import { InstallAppBannerComponent } from '../core/shared/components/install-app-banner/install-app-banner.component';
import { SearchPopupComponent } from '../core/shared/modules/search/search-popup/search-popup.component';
import { NgClass } from '@angular/common';
import { AppShellNoSSRDirective } from 'ngx-unificator/directives';
import { RouterOutlet } from '@angular/router';
import { LazyLoadImagesDirective } from 'ngx-unificator/directives';
import { SummerService } from './promo/summer/summer.service';
import { BankingService } from '../core/services/banking.service';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
  imports: [
    LazyLoadImagesDirective,
    RouterOutlet,
    AppShellNoSSRDirective,
    NgClass,
    SearchPopupComponent,
    InstallAppBannerComponent,
    ToastMessageComponent,
    GameIframeComponent,
    ToTopComponent,
  ],
})
export class PageComponent implements OnInit {
  private _user = inject(UserService);
  private _theme = inject(ThemeService);
  private _platform = inject(PlatformService);
  private _toastMessage = inject(ToastMessageService);
  private _cookies = inject(CookieService);
  private _paymentMode = inject(UserPaymentModeService);
  private _window = inject(WindowService);
  private _storage = inject(LocalstorageService);
  private _zendesk = inject(ZendeskChatService);
  private _epm = inject(EpmCountryRestrictionService);
  private _summer = inject(SummerService);
  private _banking = inject(BankingService);

  gameSearch = inject(GameSearchService);
  translations = inject(TranslationService);
  installApp = inject(InstallAppService);

  /**
   * Flag for fix click double on IOS
   * @private
   */
  private _touched: boolean;

  /**
   * Use for EMP payment popup
   */
  public empPopupData: any;

  ngOnInit() {
    this._theme.resolveTheme$();
    this._banking.fetchPayments();
    this._initSummerPromo();
    this._authHandler();
    if (this._platform.isBrowser) {
      this._user.resolveFastDeposit();
      if (!this._cookies.check('isCookiesAccepted')) {
        this.showCookiesMessage();
      }
    }

    this._fixDoubleClickOnIOS();
    this._zendesk.initChat();
  }

  /**
   * Auth handler
   */
  private _authHandler() {
    this._user.auth$
      .pipe(
        filter(auth => !!auth),
        first(),
      )
      .subscribe(() => {
        this._resolveGlobalCurrencyChange();
        this._storage.set('user_id', this._user.info.id);
      });
  }

  /**
   * Show message until user accepts cookies
   */
  showCookiesMessage() {
    this._epm.text$
      .pipe(
        tap(() => {
          const message = this._toastMessage.warning(CookieMessageContentComponent, 'key', true, false, false);
          message.callback = () => {
            setTimeout(() => {
              if (!this._cookies.check('isCookiesAccepted')) {
                this.showCookiesMessage();
              }
            }, 500);
          };
        }),
      )
      .subscribe();
  }

  private _resolveGlobalCurrencyChange() {
    this._user.currency$.subscribe(currency => {
      this._paymentMode.resolvePaymentModeOnCurrenyChange(currency);
    });
  }

  /**
   * Fix double click on IOS
   * @private
   */
  private _fixDoubleClickOnIOS() {
    if (this._platform.isBrowser && this._window.isIphoneDevices) {
      const self = this;

      document.body.addEventListener('touchstart', function() {
        if (!self._touched) {
          this.click();
          self._touched = true;
        }
      });
    }
  }

  private _initSummerPromo() {
    this._user.auth$.pipe(
      switchMap(() => this._summer.initPromo$()),
    ).subscribe();
  }
}
